<template>
  <div>
    <my-header :has_back=true></my-header>
    <div class="contents">
      <div
        v-if="is_loading"
        class="loading"
      >
        <img src="@/assets/loading.gif">
      </div>
      <div v-else>
        <div
          v-if="companies.length == 0"
          class="no_company"
        >
          対象なし
        </div>
        <div
          v-else
          v-for="(company, index) in companies"
          :key="index"
        >

          <company-card
            :propCompany="company"
            @get_companiesList="get_companiesList"
          ></company-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from "@/components/MyHeader";
import companyCard from "@/components/CompanyCard.vue";
import { AlgoliaConfig } from "@/config";
import algoliasearch from "algoliasearch";
export default {
  components: {
    companyCard,
    MyHeader
  },
  data() {
    return {
      is_loading: false,
      companies: []
    };
  },
  created() {
    this.get_companiesList();
  },
  methods: {
    get_companiesList() {
      console.log("start get_companiesList");
      const self = this;
      const client = algoliasearch(
        "D2HDGCRQ0H",
        AlgoliaConfig.apiKey
      );
      const index = client.initIndex("rakudakko");
      index
        .search({
          query: this.$store.state.search_word
        })
        .then(function(responses) {
          console.log(responses.hits);

          responses.hits.forEach(element => {
            if (element.prefectures == self.$store.state.user.pref)
              self.companies.push(element);
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.contents {
  text-align: center;
  margin-top: 1vh;
  .loading {
    line-height: 80vh;
  }
  .no_company {
    margin-top: 5vh;
    font-size: 1.5rem;
  }
}
</style>
